import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, ContentChildren, forwardRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from '@eui/components/legacy/ux-dropdown-button';
import { UxDropdownButtonItemComponent, UxDropdownButtonComponentModule, UxDropdownButtonItemComponentModule } from '@eui/components/legacy/ux-dropdown-button';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

class UxSplitButtonComponent {
    constructor() {
        this.typeClass = 'primary';
        this._isOutline = false;
        this._isDropDownRightAligned = false;
        this.dropdownIconClass = 'eui-icon eui-icon-caret-down';
        this.e2eAttr = 'ux-split-button';
        this.linkSelected = new EventEmitter();
        this.buttonClicked = new EventEmitter();
    }
    get isOutline() { return this._isOutline; }
    set isOutline(value) { this._isOutline = coerceBooleanProperty(value); }
    get isDropDownRightAligned() { return this._isDropDownRightAligned; }
    set isDropDownRightAligned(value) { this._isDropDownRightAligned = coerceBooleanProperty(value); }
    ngAfterContentInit() {
        this.btnTypeClass = 'ux-button--' + this.typeClass;
        if (this.isOutline) {
            this.btnTypeClass = 'ux-button--outline ux-button--' + this.typeClass;
        }
    }
    onLinkSelected(link) {
        this.linkSelected.emit(link);
    }
    onButtonClicked(event) {
        this.buttonClicked.emit(event);
    }
}
/** @nocollapse */ UxSplitButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxSplitButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ UxSplitButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: UxSplitButtonComponent, selector: "ux-split-button", inputs: { styleClass: "styleClass", typeClass: "typeClass", isOutline: "isOutline", label: "label", links: "links", isDropDownRightAligned: "isDropDownRightAligned", dropdownIconClass: "dropdownIconClass", e2eAttr: "e2eAttr" }, outputs: { linkSelected: "linkSelected", buttonClicked: "buttonClicked" }, queries: [{ propertyName: "items", predicate: i0.forwardRef(function () { return UxDropdownButtonItemComponent; }) }], ngImport: i0, template: `
        <div class="ux-button-group ux-split-button {{styleClass}}" attr.data-e2e="{{ e2eAttr }}">
            <button type="button" class="ux-button {{btnTypeClass}}" (click)="onButtonClicked($event)">{{label}}</button>
            <ux-dropdown-button [links]="links"
                                typeClass="{{typeClass}}" [isSplitButtonToggle]="true"
                                iconClass="{{dropdownIconClass}}"
                                [isOutline]="isOutline"
                                (linkSelected)="onLinkSelected($event)"
                                [isShowDropdownToggle]="false"
                                [isDropDownRightAligned]="isDropDownRightAligned"
                                [hasItems]="items.length !== 0">
                <ng-content></ng-content>
            </ux-dropdown-button>
        </div>
    `, isInline: true, dependencies: [{ kind: "component", type: i1.UxDropdownButtonComponent, selector: "ux-dropdown-button", inputs: ["styleClass", "label", "iconClass", "iconSvgName", "links", "activeLink", "typeClass", "dropdownMinHeight", "dropdownMaxHeight", "width", "buttonLabelAlignment", "e2eAttr", "menu", "id", "isUpdateLabelFromSelectedItem", "isDisabled", "isSmall", "isLarge", "isSplitButtonToggle", "isDropDownRightAligned", "isLinkToggle", "isOutline", "isShowDropdownToggle", "hasItems", "isSecondary", "isBlock"], outputs: ["linkSelected"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxSplitButtonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ux-split-button',
                    template: `
        <div class="ux-button-group ux-split-button {{styleClass}}" attr.data-e2e="{{ e2eAttr }}">
            <button type="button" class="ux-button {{btnTypeClass}}" (click)="onButtonClicked($event)">{{label}}</button>
            <ux-dropdown-button [links]="links"
                                typeClass="{{typeClass}}" [isSplitButtonToggle]="true"
                                iconClass="{{dropdownIconClass}}"
                                [isOutline]="isOutline"
                                (linkSelected)="onLinkSelected($event)"
                                [isShowDropdownToggle]="false"
                                [isDropDownRightAligned]="isDropDownRightAligned"
                                [hasItems]="items.length !== 0">
                <ng-content></ng-content>
            </ux-dropdown-button>
        </div>
    `
                }]
        }], propDecorators: { styleClass: [{
                type: Input
            }], typeClass: [{
                type: Input
            }], isOutline: [{
                type: Input
            }], label: [{
                type: Input
            }], links: [{
                type: Input
            }], isDropDownRightAligned: [{
                type: Input
            }], dropdownIconClass: [{
                type: Input
            }], e2eAttr: [{
                type: Input
            }], linkSelected: [{
                type: Output
            }], buttonClicked: [{
                type: Output
            }], items: [{
                type: ContentChildren,
                args: [forwardRef(() => UxDropdownButtonItemComponent)]
            }] } });
class UxSplitButtonComponentModule {
}
/** @nocollapse */ UxSplitButtonComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxSplitButtonComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxSplitButtonComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxSplitButtonComponentModule, declarations: [UxSplitButtonComponent], imports: [CommonModule, UxDropdownButtonComponentModule, UxDropdownButtonItemComponentModule], exports: [UxSplitButtonComponent] });
/** @nocollapse */ UxSplitButtonComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxSplitButtonComponentModule, imports: [CommonModule, UxDropdownButtonComponentModule, UxDropdownButtonItemComponentModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxSplitButtonComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, UxDropdownButtonComponentModule, UxDropdownButtonItemComponentModule],
                    exports: [UxSplitButtonComponent],
                    declarations: [UxSplitButtonComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { UxSplitButtonComponent, UxSplitButtonComponentModule };
